"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _calculateSaving = _interopRequireDefault(require("./calculateSaving"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(employees, fot, contribution, avgPayment) {
  avgPayment = fot / employees;
  var indexedFot = fot * contribution + fot;
  var indexedAvgPayment = indexedFot / employees;
  var additionalContribution = (0, _calculateSaving.default)(indexedAvgPayment, employees) - (0, _calculateSaving.default)(avgPayment, employees);
  return additionalContribution;
}